import React from 'react';
import { LangContext } from '../../contexts/LangContext';
import './StoreHeader.css';

const LANG_OPTIONS = [
  { code: 'BRL', flag: 'img/brazil-flag.png' },
  { code: 'USD', flag: 'img/america-flag.png' },
];

export default function StoreHeader({
  activePage = 'loja',
  showLoki = false,
  tabsDisabled = false,
  onNavigate,
  onHistorico,
  onLoyaltyPass,
  onCart,
  npBalance = 0,
  cartCount = 0,
  cartEntries = [],
  cartAction = null,
  lang,
  onLangChange,
}) {
  const { t } = React.useContext(LangContext);
  const nav = (page) => onNavigate && onNavigate(page);

  const [langOpen, setLangOpen]       = React.useState(false);
  const [cartHovered, setCartHovered] = React.useState(false);
  const cartLeaveTimer = React.useRef(null);

  const handleCartEnter = () => {
    clearTimeout(cartLeaveTimer.current);
    setCartHovered(true);
  };

  const handleCartLeave = () => {
    cartLeaveTimer.current = setTimeout(() => setCartHovered(false), 900);
  };

  const currentLang = LANG_OPTIONS.find((o) => o.code === lang) || LANG_OPTIONS[0];
  const s = t.component.shop;
  const lp = t.component.loyaltyPath;

  return (
    <header className={`store-header${tabsDisabled ? ' store-header--cart-open' : ''}`}>
      {/* Esquerda */}
      <div className="left-group">
        <button className="ghost-btn ghost-btn-historico" onClick={onHistorico}>
          {s.history}
        </button>
        {onLoyaltyPass && (
          <button className="ghost-btn ghost-btn-loyalty" onClick={onLoyaltyPass}>
            {lp.title}
          </button>
        )}
      </div>

      {/* Centro */}
      <div className="center-group">
        <button
          className={`tab${activePage === 'evento' && !tabsDisabled ? ' tab-active' : ''}`}
          onClick={() => nav('evento')}
        >
          {s.tabs.evento}
        </button>
        <button
          className={`tab${activePage === 'loja' && !tabsDisabled ? ' tab-active' : ''}`}
          onClick={() => nav('loja')}
        >
          {s.tabs.loja}
        </button>
        {showLoki && (
          <button
            className={`tab tab--season${activePage === 'loki' && !tabsDisabled ? ' tab-active' : ''}`}
            onClick={() => nav('loki')}
          >
            {s.tabs.loki}
          </button>
        )}
      </div>

      {/* Direita */}
      <div className="right-group">

        {/* Idioma */}
        <div className="lang-wrapper">
          <button
            className="lang-trigger"
            onClick={() => setLangOpen((o) => !o)}
          >
            <span className="lang-text">{currentLang.code}</span>
            <img src={currentLang.flag} alt={currentLang.code} className="flag-img" />
            <span className="lang-chevron">{langOpen ? '▴' : '▾'}</span>
          </button>

          {langOpen && (
            <div className="lang-dropdown">
              {LANG_OPTIONS.map((opt) => (
                <button
                  key={opt.code}
                  className="lang-option"
                  onClick={() => { onLangChange(opt.code); setLangOpen(false); }}
                >
                  <span>{opt.code}</span>
                  <img src={opt.flag} alt={opt.code} className="flag-img" />
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Saldo NP */}
        <div className="balance-group">
          <span className="balance-label">{s.balance}</span>
          <span className="np-icon-wrapper">
            <img src="img/icons/np2.png" alt="NP" className="np-balance-icon" />
          </span>
          <span className="balance-value">{npBalance.toLocaleString('pt-BR')}</span>
        </div>

        {/* Carrinho com tooltip */}
        <div
          className="cart-wrapper"
          onMouseEnter={handleCartEnter}
          onMouseLeave={handleCartLeave}
        >
          {cartAction && (
            <span key={cartAction.id} className={`cart-action-label cart-action-label--${cartAction.type}`}>
              {cartAction.type === 'added' ? s.cart.itemAdded : s.cart.itemRemoved}
            </span>
          )}
          <button className={`cart-btn${cartAction ? ' cart-btn-pump' : ''}`} onClick={onCart}>
            <img src="img/cart2.png" alt="carrinho" className="cart-icon" />
            <span className="cart-badge">{cartCount}</span>
          </button>

          {(cartHovered || cartAction) && (
            <div className="cart-tooltip">
              <div className="cart-tooltip-title">
                {cartCount > 0
                  ? `${cartCount} ${s.cart.items}`
                  : s.cart.empty}
              </div>

              {cartEntries.length > 0 ? (
                <>
                  {cartEntries.map(({ item, qty }) => (
                    <div key={item.sku} className="cart-tooltip-item">
                      <span className="cart-tooltip-item-name">{item.name}</span>
                      <span className="cart-tooltip-item-qty">x{qty}</span>
                    </div>
                  ))}
                  <div className="cart-tooltip-divider" />
                  <div className="cart-tooltip-total">
                    {s.cart.total}{' '}
                    {cartEntries
                      .reduce((sum, { item, qty }) => sum + item.brlPriceValue * qty, 0)
                      .toLocaleString(lang === 'USD' ? 'en-US' : 'pt-BR', {
                        style: 'currency',
                        currency: lang === 'USD' ? 'USD' : 'BRL',
                      })}
                  </div>
                </>
              ) : (
                <div className="cart-tooltip-total-left">{s.cart.add}</div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
